import React from 'react'

export default function TermsConditions() {
  return (
    <div className="section commonHeaderPadding">
      <div className="container-fluid maxContainerSection container-privacy-policy">
        <h2 className='text-center f-s-48 f-w-700 pb-4'>Terms and Conditions</h2>

        <p className='m-0 pb-1'>
          By accessing and using the Quimenergy website, you agree to comply with and be bound by the following terms and conditions. If you do not agree, you should not use this website.
        </p>

        <h3 className='m-0 pt-4 pb-2'>1. Use of the Website</h3>

        <p className='m-0 pb-1'>
          This website is intended to provide general information about Quimenergy’s services, projects, and capabilities. The content is for informational purposes only and does not constitute a commercial offer or binding agreement.
        </p>

        <p className='m-0 pb-1'>
          Users agree to use the website responsibly and not to engage in any activity that may disrupt its functionality or compromise its security.
        </p>

        <h3 className='m-0 pt-4 pb-2'>2. Services and Information</h3>

        <p className='m-0 pb-1'>
          Quimenergy operates in the energy and industrial sectors, including Oil & Gas, Renewable Energy, and EPC & Infrastructure. Any information provided on this website is subject to change without prior notice.
        </p>

        <p className='m-0 pb-1'>
          Project details, service descriptions, and capabilities are indicative and may vary depending on specific contractual agreements.
        </p>

        <h3 className='m-0 pt-4 pb-2'>3. Intellectual Property</h3>

        <p className='m-0 pb-1'>
          All content on this website, including text, logos, graphics, and design elements, is the property of Quimenergy or its partners and is protected by applicable intellectual property laws.
        </p>

        <p className='m-0 pb-1'>
          No content may be copied, reproduced, or distributed without prior written consent.
        </p>

        <h3 className='m-0 pt-4 pb-2'>4. Limitation of Liability</h3>

        <p className='m-0 pb-1'>
          Quimenergy shall not be held liable for any direct or indirect damages arising from the use or inability to use this website.
        </p>

        <p className='m-0 pb-1'>
          We do not guarantee uninterrupted or error-free access to the website and are not responsible for any inaccuracies or omissions in the content.
        </p>

        <h3 className='m-0 pt-4 pb-2'>5. External Links</h3>

        <p className='m-0 pb-1'>
          This website may contain links to third-party websites. Quimenergy is not responsible for the content, accuracy, or practices of such external sites.
        </p>

        <h3 className='m-0 pt-4 pb-2'>6. Data Protection and Privacy</h3>

        <p className='m-0 pb-1'>
          Any personal data submitted through this website, including subscription forms, will be handled in accordance with our Privacy Policy.
        </p>

        <p className='m-0 pb-1'>
          Users are responsible for ensuring that the information they provide is accurate and up to date.
        </p>

        <h3 className='m-0 pt-4 pb-2'>7. Changes to Terms</h3>

        <p className='m-0 pb-1'>
          Quimenergy reserves the right to update or modify these Terms and Conditions at any time without prior notice. Continued use of the website constitutes acceptance of those changes.
        </p>

        <h3 className='m-0 pt-4 pb-2'>8. Governing Law</h3>

        <p className='m-0 pb-1'>
          These Terms and Conditions are governed by the laws of the Republic of Angola. Any disputes arising in connection with the use of this website shall be subject to the jurisdiction of the Angolan courts.
        </p>

        <p className='m-0 pb-1'>
          For any questions regarding these Terms and Conditions, please contact us at: <a href="mailto:Geral@quimenergy.ao">Geral@quimenergy.ao</a>
        </p>

      </div>
    </div>
  )
}
